import { z } from 'zod'
import { oc } from '@orpc/contract'
import { assistantProviderSchema } from './assistant-conversation.contract'

export const assistantConfig = oc
  .route({ method: 'GET', path: '/v2/assistant/config' })
  .input(z.object({}).optional())
  .output(
    z.object({
      debugTools: z.boolean(),
      maxTokens: z.number().optional(),
      providers: z
        .array(
          z.object({
            provider: assistantProviderSchema,
            models: z.array(z.string()),
          }),
        )
        .optional(),
    }),
  )
